// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appUrl: 'https://screenfortype1-website-2025.dev.havashps.cloud',
  apiServer:
    'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D4x000006qcKd',
  oid: '00D4x000006qcKd',
  retURL: '/thank-you/',
  countryCode: 'US',
  leadSource: 'www.screenfortype1.com/stayconnected',
  MVN_Interaction_Type__c: 'Consumer',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
